module.exports = __webpack_public_path__ + "img/104082.51da9ddc.png";